export const GET_EXCO_KELURAHAN = "GET_EXCO_KELURAHAN";
export const GET_EXCO_KELURAHAN_SUCCESS = "GET_EXCO_KELURAHAN_SUCCESS";
export const GET_EXCO_KELURAHAN_FAIL = "GET_EXCO_KELURAHAN_FAIL";
